import {create} from 'zustand';
import {DuplicityAuthStore} from './types';

const useDuplicityAuthStore = create<DuplicityAuthStore>(set => ({
	duplicityAuth: undefined,
	setDuplicityAuth: value => set({duplicityAuth: value}),
}));

export {useDuplicityAuthStore};
